import { Component, OnInit, ViewChild } from '@angular/core';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { MessageService } from '@progress/kendo-angular-l10n';
import { process } from '@progress/kendo-data-query';
import { Locker } from 'src/app/models/locker.model';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { lockers } from 'src/app/resources/lockers';
import { images } from 'src/app/resources/images';
import { DialogContentBase, DialogRef, DialogService } from "@progress/kendo-angular-dialog";
import { HorizontalAlign } from '@progress/kendo-angular-layout';
import { SharingService } from 'src/app/services/sharing.service';
import { BaseHttpResponse } from 'src/app/models/base-http-response';
import { ApiService } from 'src/app/services/http/api.service';
import { Modulo } from 'src/app/models/modulo.model';
import { Router } from '@angular/router';
import { Compartimento } from 'src/app/models/compartimento.model';
import { Anomaly } from '../../models/anomaly.model';
import { CompartimentoEstado } from '../../models/compartimento.model';

@Component({
    selector: 'app-lockers-details-component',
    templateUrl: './lockers-details.component.html'
})
export class LockersDetailsComponent extends DialogContentBase implements OnInit {
    @ViewChild(DataBindingDirective) dataBinding?: DataBindingDirective;
    public hAlign: HorizontalAlign = "start";
    public gridData: Locker[] = lockers;
    public gridView: any[] = [];
    public locker: Locker = {
        id: 0,
        nomeLocal: '',
        refLocal: 0,
        refModeloArmario: 0,
        nomeModeloArmario: '',
        numeroDeSerie: '',
        nome: '',
        dimensaoTotal: '',
        numeroUtilDeCacifos: '',
        modulos: []
    };
    public mySelection: string[] = [];
    public modulos: Modulo[] = [];
    public customMsgService: CustomMessagesService;

    constructor(private router: Router, private sharingService: SharingService, public msgService: MessageService, private dialogService: DialogService, public override dialog: DialogRef, private api: ApiService) {
        super(dialog);
        this.customMsgService = this.msgService as CustomMessagesService;
    }

    backHome() {
        this.router.navigate(['/lockers']);
    }

    load() {
        this.api
            .getRequest<BaseHttpResponse<Modulo[]>>("Armario/GetConfiguracaoModulosArmario?idArmario=" + this.locker?.id)
            .then((data) => {
                this.modulos = data.value;
            })
            .catch((err) => { });
    }

    public ngOnInit(): void {
        this.locker = this.sharingService.sharingValue;
        this.load();
        this.gridView = this.gridData;
    }

    public onFilter(inputValue: string): void {
        this.gridView = process(this.gridData, {
            filter: {
                logic: 'or',
                filters: [
                    {
                        field: this.getField,
                        operator: 'contains',
                        value: inputValue
                    }
                ]
            }
        }).data;
        this.dataBinding ? this.dataBinding.skip = 0 : null;
    }

    public getField = (args: Locker) => {
        return `${args.nome}_$`;
    }

    public photoURL(dataItem: any): string {
        const code: string = dataItem.imgId + dataItem.gender;
        const image: any = images;
        return image[code];
    }

    public flagURL(dataItem: any): string {
        const code: string = dataItem.country;
        const image: any = images;
        return image[code];
    }

    //Box Details Dialog
    public getTranslatedText(c: Compartimento): string {
        var inibido = this.customMsgService.translate('no');
        if (c.compartimentoEstado.bloqueado == true) {
            inibido = this.customMsgService.translate('yes');
        } 
        var condicao = this.customMsgService.translate('ativa');
        if (c.compartimentoEstado.ferramentaBloqueada == true) {
            condicao = this.customMsgService.translate('bloqueada');
        }

        var text = ``;
        if (c.compartimentoEstado.refFerramenta != null && c.compartimentoEstado.refArtigo == null && c.compartimentoEstado.ferramentaAvariada == true) {
            text = `${this.customMsgService.translate('name')}: ${c.nome}
${this.customMsgService.translate('size')}: ${c.descricaoTamanho}
${this.customMsgService.translate('addressCanal')}: ${c.endereco}
${this.customMsgService.translate('inibido')}: ${inibido}

${this.customMsgService.translate('tool')}: ${c.compartimentoEstado.descricaoFerramenta}
${this.customMsgService.translate('tooltype')}: ${c.compartimentoEstado.descricaoTipoFerramenta}
${this.customMsgService.translate('condicao')}: ${condicao}
${this.customMsgService.translate('avaria')}: ${c.compartimentoEstado.descricaoAvariaFerramenta}`;

        }
        else if (c.compartimentoEstado.refFerramenta != null && c.compartimentoEstado.refArtigo == null && c.compartimentoEstado.ferramentaAvariada == false) {
            text = `${this.customMsgService.translate('name')}: ${c.nome}
${this.customMsgService.translate('size')}: ${c.descricaoTamanho}
${this.customMsgService.translate('addressCanal')}: ${c.endereco}
${this.customMsgService.translate('inibido')}: ${inibido}

${this.customMsgService.translate('tool')}: ${c.compartimentoEstado.descricaoFerramenta}
${this.customMsgService.translate('tooltype')}: ${c.compartimentoEstado.descricaoTipoFerramenta}
${this.customMsgService.translate('condicao')}: ${condicao}
${this.customMsgService.translate('avaria')}: ${this.customMsgService.translate('nenhuma')}`;

        }
        else if (c.compartimentoEstado.refFerramenta == null && c.compartimentoEstado.refArtigo != null && c.compartimentoEstado.refAnomalia != null) {
            text = `${this.customMsgService.translate('name')}: ${c.nome}
${this.customMsgService.translate('size')}: ${c.descricaoTamanho}
${this.customMsgService.translate('addressCanal')}: ${c.endereco}
${this.customMsgService.translate('inibido')}: ${inibido}

${this.customMsgService.translate('anomalia')}: ${c.compartimentoEstado.descricaoAnomalia}
${this.customMsgService.translate('artigo')}: ${c.compartimentoEstado.descricaoArtigo}
${this.customMsgService.translate('codigoInterno')}: ${c.compartimentoEstado.codigoInternoArtigo}
${this.customMsgService.translate('stock')}: ${c.compartimentoEstado.stock}`;
        }

        else if (c.compartimentoEstado.refFerramenta == null && c.compartimentoEstado.refArtigo != null && c.compartimentoEstado.refAnomalia == null) {
            text = `${this.customMsgService.translate('name')}: ${c.nome}
${this.customMsgService.translate('size')}: ${c.descricaoTamanho}
${this.customMsgService.translate('addressCanal')}: ${c.endereco}
${this.customMsgService.translate('inibido')}: ${inibido}
  
${this.customMsgService.translate('artigo')}: ${c.compartimentoEstado.descricaoArtigo}
${this.customMsgService.translate('codigoInterno')}: ${c.compartimentoEstado.codigoInternoArtigo}
${this.customMsgService.translate('stock')}: ${c.compartimentoEstado.stock}`;
        }

        else {
            text = `${this.customMsgService.translate('name')}: ${c.nome}
${this.customMsgService.translate('size')}: ${c.descricaoTamanho}
${this.customMsgService.translate('addressCanal')}: ${c.endereco}
${this.customMsgService.translate('inibido')}: ${inibido}`;
        }
        return text;

    }

    public getText(c: Compartimento): string {
        var text = ``;
        if (c.compartimentoEstado.refFerramenta != null && c.compartimentoEstado.refArtigo == null) {
            text = `${c.compartimentoEstado.descricaoFerramenta}`;

        }
        else if (c.compartimentoEstado.refFerramenta == null && c.compartimentoEstado.refArtigo != null) {
            text = `${c.compartimentoEstado.descricaoArtigo.substring(0, 8)} (${c.compartimentoEstado.stock} un.)`;
        }
        else {
            text = ``;
        }
        return text;

    }

    public stockBaixo(c: Compartimento): boolean {

        var stock = c.compartimentoEstado.stock;
        var stockMin = c.quantidadeAlertaStock;

        if (stock <= stockMin && c.compartimentoEstado.refArtigo == c.refArtigo && c.refArtigo != null && c.quantidadeDesejada > 0) {
            return  true;
        }
        return  false;
    }

    public alertaCor(c: Compartimento): string {
        
        if (c.compartimentoEstado.bloqueado == true || c.hmi == true){
            return 'box greybox'
        } 
        else if (c.compartimentoEstado.refAnomalia != null){
            return 'box redbox'
        }
        else if (this.stockBaixo(c) == true){
            return 'box yellowbox'
        }
        else{
            return '';
        }
    }

    estadoBtn(c: Compartimento): string {
        if (c.hmi == true) {
            return "width: 60px; height: 20px;";
        }
        else {
            return "width: 20px; height: 20px;";
        }
    }

}